import { render, staticRenderFns } from "./PrintTemplateManager.vue?vue&type=template&id=6ff7970a&scoped=true"
import script from "./PrintTemplateManager.vue?vue&type=script&lang=js"
export * from "./PrintTemplateManager.vue?vue&type=script&lang=js"
import style0 from "./PrintTemplateManager.vue?vue&type=style&index=0&id=6ff7970a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff7970a",
  null
  
)

export default component.exports